/* eslint-disable eqeqeq */
import DocumentStatusEnum from '../../../../../enums/DocumentStatusEnum.js';
import UserRole from '../../../../../enums/UserRole.js';

export function getDisplayFromStatusHelper(status, user) {
  const canReviewDocuments =
    user?.role === UserRole.ADMIN || user?.role === UserRole.COLLABORATOR;
  const canBeApproved =
    status === DocumentStatusEnum.VALIDATING ||
    status === DocumentStatusEnum.REJECTED;

  if (canReviewDocuments && canBeApproved) {
    return 'block';
  }
  return 'none';
}

export function getDisplayFromStatusHelperToAproveRejectDocuments(status, user) {
  return getDisplayFromStatusHelper(status, user);
}

export function shouldShowDeclineButton(status, user) {
  const isAdmin = user.role === UserRole.ADMIN || user.role === UserRole.COLLABORATOR;
  const isValidatingOrCompleted =
    status === DocumentStatusEnum.VALIDATING || status === DocumentStatusEnum.COMPLETED;

  return isAdmin && isValidatingOrCompleted ? 'block' : 'none';
}
